import type { SVGProps } from 'react';

const SvgImageAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 16H6c-.4 0-.74-.24-.9-.58l2.93-2.2 2.41 1.61c.36.24.84.22 1.18-.05l5-4c.43-.35.5-.97.16-1.41-.35-.43-.97-.5-1.41-.16l-4.43 3.54-2.39-1.59a.99.99 0 0 0-1.15.03L5 12.99v-6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-1.65-1.35-3-3-3H6c-1.65 0-3 1.35-3 3v8c0 1.65 1.35 3 3 3h6c.55 0 1-.45 1-1s-.45-1-1-1z"
    />
    <path
      fill="currentcolor"
      d="M11.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M22 15h-2v-2c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgImageAdd;
